import { render, staticRenderFns } from "./ProductAcqLimit.vue?vue&type=template&id=7cf1b10a&"
import script from "./ProductAcqLimit.vue?vue&type=script&lang=js&"
export * from "./ProductAcqLimit.vue?vue&type=script&lang=js&"
import style0 from "./ProductAcqLimit.vue?vue&type=style&index=0&id=7cf1b10a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports